export default __webpack_public_path__ + "static/media/lab3.6cee9650.png";